import type { NavItem } from '@/app/nav/collect'

/**
 * The `on` menu's "Onboarding" and "Offboarding" items are the legacy menu, declared once by the shell
 * (`src/modules/shell/nav.ts`, ids `on-onboarding` / `on-offboarding`, `?stage=0`) and already pointing at this module's
 * paths. Legacy had no other entry, so the module adds none.
 */
const nav: NavItem[] = []

export default nav
